export default function(configData){
    localStorage.setItem(`user_acount_id`,configData.data.account.id)
    localStorage.setItem(`user_website`,JSON.stringify(configData.data.account.website))
    localStorage.setItem(`user_websites`,JSON.stringify(configData.data.account.websites))
}